/**
 * The as-of stamp, in the deployment's locale and timezone.
 *
 * `MING_TIMEZONE` rather than the renderer's, because the renderer is a
 * headless browser in a container and its idea of local time is UTC. A report
 * that said it ran at a time nobody recognises is exactly the failure that
 * setting exists to prevent.
 */
export function formatStamp(
  value: string | null | undefined,
  locale: string,
  timeZone: string | undefined,
): string {
  const when = value ? new Date(value) : new Date();
  if (Number.isNaN(when.getTime())) return "—";
  try {
    return new Intl.DateTimeFormat(locale, {
      dateStyle: "medium",
      timeStyle: "short",
      timeZone,
    }).format(when);
  } catch {
    return when.toISOString().slice(0, 16).replace("T", " ");
  }
}

